import React from "react";

import LargeCheckmark from "../../../assets/CheckmarkLarge";

const InitialSubmissionScreen = () => {
  return (
    <>
      <div className="stepDescriptionText">
        You&apos;ve successfully submitted your application.
      </div>
      <div className="flex items-center flex-col justify center ">
        <LargeCheckmark className="mb-8" />
        <div className='text-xl mx-5 text-center text-gray-600 mb-6'>
          We will notify you about the status of your application soon.
        </div>
      </div>

    </>
  );
};

export default InitialSubmissionScreen;
